import productsService from '../../../../services/products';

const bulkArticles = idMap => articles => {
  /**
   * @param id
   * @returns {{iows: {qty: number, itemno: *, type: string}, id: *}}
   */
  const createCollectionArticleObject = id =>
    productsService.getProduct(idMap[id].id);

  const itemIds = Object.keys(idMap)
    .filter(id => createCollectionArticleObject(id))
    .map(id => id, 10);

  const itemsIds = itemIds.reduce(
    (acc, curr) => ({
      ...acc,
      [curr]: [],
    }),
    {}
  );

  /**
   * Derive articles from array based on idMap
   * @param reversed
   * @returns {function({id?: *}): boolean}
   */
  const collectArticles =
    (reversed = false) =>
    ({ id }) =>
      reversed ? !itemIds.includes(id) : itemIds.includes(id);

  /**
   * Sorts all shelves into arrays, by id
   * @param acc
   * @param curr
   */
  const sortArticles = (acc, curr) => ({
    ...acc,
    [curr.id]: [...acc[curr.id], curr],
  });

  /**
   * Splits items into smaller given chunks
   * @param items
   * @param obj
   * @returns {*[]|*}
   */
  const itemSplitter = (items, obj = []) => {
    const itemId = items[0]?.id || null;
    const multipackItem = itemId ? idMap[itemId] : null;
    const isMultipackOnly = productsService.isOnlyAvailableInMultipack(itemId);
    const bulkSize = multipackItem?.bulkSize || null;

    if (!items.length || (!isMultipackOnly && items.length < bulkSize))
      return [...obj, ...items];

    const bulk = items.slice(0, bulkSize);
    const rest = items.slice(bulkSize, items.length);
    return itemSplitter(rest, [
      ...obj,
      createCollectionArticleObject(bulk[0].id),
    ]);
  };

  /**
   * Assembles the 4 packs, and rest of shelves
   * @returns {*[]}
   */
  const assembleShelvesArray = () => {
    const itemsExcludingShelves = articles.filter(collectArticles(true));

    const shelves = articles
      .filter(collectArticles())
      .reduce(sortArticles, itemsIds);

    const groupedShelves = Object.values(shelves)
      .map(art => itemSplitter(art))
      .flat();

    return [...itemsExcludingShelves, ...groupedShelves];
  };

  return assembleShelvesArray();
};

export default bulkArticles;
